export const SCREEN_SIZE = {
   TABLET: '(max-width:768px)',
   PHONE: '(max-width:425px)'
};
